import { ConfigurationItem } from "constants/configurations";
import type { Dispatch } from "react-redux";
import {
  setSelectedConfigurationTab,
  type ConfigurationDispatchAction,
} from "redux/actions";
import { setSelectedConfigurationTabInStorage } from "shared/storageUtils";

export const updateSelectedConfigurationTab =
  (itemId: ConfigurationItem) =>
  (dispatch: Dispatch<ConfigurationDispatchAction>) => {
    setSelectedConfigurationTabInStorage(itemId.toString());
    dispatch(setSelectedConfigurationTab(itemId));
  };
